import { Getters } from "vuex";
import { ExchangeGetters, ExchangeState } from "./types";

export const getters: Getters<ExchangeState, ExchangeGetters> = {};
